var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('SideBar'),_c('TopBar'),_c('div',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }